import './App.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Router } from 'react-router-dom';

import AppRoutes from './routes';
import { IState } from './types';
import history from './utils/history';
import { withDefaultStyles } from './utils/material-ui/hoc';

class App extends React.Component<IState, IState> {
  public render() {
    return (
      <div>
        <Router history={history}>
          <AppRoutes />
        </Router>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default withDefaultStyles(connect(
  mapStateToProps
)(App));



// WEBPACK FOOTER //
// ./src/App.tsx